import { useState } from 'react';
import { Group, Button, Text, Stack } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { imprimir, compartir } from '../../utils/impresion';

/**
 * Los dos caminos a la impresora del stand, uno al lado del otro.
 *
 * No podemos detectar desde el navegador si la impresora que hay enfrente es
 * AirPrint o Bluetooth, así que se ofrecen los dos y el operador aprende en el
 * primer minuto cuál anda. El día del congreso eso es un dato que ya sabe.
 *
 * El blob llega compuesto desde afuera: navigator.share necesita el gesto del
 * usuario, y componer la imagen dentro del onClick lo pierde en iOS.
 */
export function BotonesImpresion({ blob, nombreArchivo, titulo = 'FORVET', onUso }) {
  const [ocupado, setOcupado] = useState(null);

  async function correr(que, fn) {
    setOcupado(que);
    onUso?.();
    try {
      await fn();
    } catch (err) {
      notifications.show({
        message: 'No pudimos abrir la impresión. Probá con el otro botón.',
        color: 'orange',
      });
      console.error('[impresion]', err);
    } finally {
      setOcupado(null);
    }
  }

  return (
    <Stack align="center" gap={6}>
      <Group gap="sm">
        <Button
          variant="outline" size="md"
          loading={ocupado === 'imprimir'} disabled={!blob}
          onClick={() => correr('imprimir', () => imprimir(blob, titulo))}
        >
          IMPRIMIR
        </Button>

        <Button
          variant="outline" size="md"
          loading={ocupado === 'compartir'} disabled={!blob}
          onClick={() => correr('compartir', async () => {
            const r = await compartir(blob, nombreArchivo);
            if (r === 'descargado') {
              notifications.show({
                message: 'Se descargó la imagen. Abrila desde la app de la impresora.',
                color: 'blue',
              });
            }
          })}
        >
          ENVIAR A LA IMPRESORA
        </Button>
      </Group>

      <Text size="xs" c="dimmed" ta="center" maw={420}>
        IMPRIMIR abre el diálogo del sistema. ENVIAR sirve para las impresoras
        Bluetooth que se manejan con su propia app.
      </Text>
    </Stack>
  );
}
